const form = document.querySelector('form[name="validate-email-form"]');
const form_data = JSON.parse(document.getElementById('validate-form-data').textContent);
console.log(form_data)
form.addEventListener('submit', function(event) {
  event.preventDefault();
    const loading = form.querySelector(".button .loading");
  
    const email = document.getElementById('validate-email').value;
    const login_url = form.dataset.loginUrl;
    const register_url = form.dataset.registerUrl;

    if (loading) loading.classList.remove("hidden");

    fetch('https://ipkg92xvbi.execute-api.eu-west-1.amazonaws.com/prd/shopify/checkemail', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${form_data.validate_api_key}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ "email": email })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Server error response(01): ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (data.userExists === "false") {
        window.location.href = register_url;
      } else {
        window.location.href = login_url + '&email=' + encodeURIComponent(email);
      }
    })
    .catch(error => {
      if (loading) loading.classList.add("hidden");
      console.error('Fetch failed:', error.message, error);
      alert(`Error: ${error.message}`);
    });
        
});
